import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeVideo extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: props.locale,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className={`object-container`}>
                <div className={`prototype video-container`}>
                    <div className="video-thumbnail-wrapper">
                        <div className={`video-controls play`}>
                            <img src={require(`../../../assets/images/placeholder/placeholder_thumbnail.jpg`)} alt=""/>
                        </div>
                    </div>
                    <div className="video-details">
                        <h4 className="viewed" dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_TEXT_TITLE}}/>
                        <div dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_TEXT}}/>
                    </div>
                </div>
            </div>
        );
    }
}

PrototypeVideo.propTypes = {
    locale: PropTypes.object,
};

PrototypeVideo.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeVideo);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeVideo.js
 **/